import {
  withCompPreviewInfo,
  createComponentPreviewMapperModel,
} from '@wix/editor-elements-integrations';
import {
  PopupContainerDefinition,
  PopupContainerProps as PopupContainerPlatformProps,
} from '@wix/thunderbolt-components';
import { PreviewWrapperProps } from '@wix/editor-elements-types';
import { PopupContainerPreviewProps } from '../PopupContainer.types';

const props = withCompPreviewInfo<
  PreviewWrapperProps<PopupContainerPlatformProps, PopupContainerPreviewProps>,
  PopupContainerDefinition,
  PopupContainerPlatformProps
>()(
  ['componentViewMode', 'isMobileView'],
  ({ componentViewMode, isMobileView }, { fillLayers, ...carmiData }) => {
    return {
      ...carmiData,
      fillLayers: {
        ...fillLayers,
        reducedMotion: true,
      },
      previewWrapperProps: {
        componentViewMode,
        isMobileView,
      },
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
